import 'core-js/actual';
import 'react-app-polyfill/ie11';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { unregister } from 'registerServiceWorker';
import { IS_LOCAL_DEV } from 'config/envVariable';
import dynamicImport from './dynamicImport';
import App from './App';
import { createScript, createTagManger } from 'utils/createElement';
import generateCSP, { isClientFlow } from 'generateCSP';

dynamicImport()
    .then(async () => {
        if (isClientFlow(window.location.pathname)) {
            const nonce = await generateCSP();
            return nonce;
        }
    })
    .then(nonce => {
        const isEdit = window.location.pathname.indexOf('/edit') > 0;
        const feverGTM = isEdit ? 'GTM-WLQ8G7' : 'GTM-NP4F5B';
        createTagManger(feverGTM, nonce);
        createScript('//platform.instagram.com/en_US/embeds.js', nonce);
    })
    .then(() => initApp())
    .catch(() => initApp());

function initApp() {
    const renderApp = () => {
        const container = document.getElementById('root');
        const root = createRoot(container);
        return root.render(<App />);
    };

    renderApp();
    unregister();

    if (IS_LOCAL_DEV && module.hot) {
        module.hot.accept('./App', renderApp);
    }
}
